import store from '@/store'

import { colatex2svg } from '@/utils/tools'

const getSceneName = function (key) {
  let name = ''
  // 授课场景：1，老师教；2，AI课；3，自由练；
  switch (key) {
    case 1:
      name = '老师教'
      break
    case 2:
      name = 'AI课'
      break
    case 3:
      name = '自由练'
      break
    default:
      name = '自由练'
      break
  }
  return name
}
const getStateName = function (key) {
  let name = ''
  // 讲次状态：0，未上课/未开始；1，上课中/进行中；2，已下课/已完成 3，已移除
  switch (key) {
    case 0:
      name = '未开始'
      break
    case 1:
      name = '进行中'
      break
    case 2:
      name = '已完成'
      break
    case 3:
      name = '已移除'
      break
    default:
      name = '未开始'
      break
  }
  return name
}
const getClassStatusName = function (key) {
  let name = ''
  // 讲次状态：0，未上课/未开始-上课；1，上课中/进行中-监课；2，已下课/已完成-继续上课 3，已移除-继续上课
  switch (key) {
    case 0:
      name = '上课'
      break
    case 1:
      name = '监课'
      break
    case 2:
      name = '继续上课'
      break
    case 3:
      name = '继续上课'
      break
    default:
      name = '上课'
      break
  }
  return name
}
const getBookStateName = function (key) {
  let name = ''
  // 订正完成状态， 0 未完成 1已完成  3 无错题
  switch (key) {
    case 0:
      name = '未订正'
      break
    case 1:
      name = '已完成'
      break
    case 3:
      name = '无错题'
      break
    default:
      name = '未订正'
      break
  }
  return name
}
const getResultName = function (key, state) {
  let name = ''

  if (state === 1 || state === 3) {
    name = '未作答'
    return name
  }

  // 答题结果 0 答错 1 答对 2 半对半错
  switch (key) {
    case 0:
      name = '错误'
      break
    case 1:
      name = '正确'
      break
    case 2:
      name = '半对半错'
      break
    default:
      name = '错误'
      break
  }
  return name
}
const getAttendanceName = function (key) {
  let name = ''
  // 学生出勤状态 1 已上课，2 缺勤
  switch (key) {
    case 1:
      name = '已上课'
      break
    case 2:
      name = '缺勤'
      break
    case 3:
      name = '上课中'
      break
    default:
      name = '缺勤'
      break
  }
  return name
}
const getFinishedName = function(key) {
  let name = ''
  // 自我巩固完成状态 0：未完成  1：已完成  3：全对无需自我巩固(2.0版本去掉)
  switch (key) {
    case 0:
      name = '未完成'
      break
    case 1:
      name = '已完成'
      break
    default:
      name = '已完成'
      break
  }
  return name
}
const formatPercent = function (point, isUnit = true) {
  let result
  if (point || point === 0) {
    // result = Math.ceil(Number(point) * 100)
    result = Number(parseFloat(point * 100).toFixed(0))
    if (isUnit) {
      result += '%'
    }
  }
  return result ?? '--'
}
const optionsName = function (value) {
  let result = value
  if (typeof value === 'number') {
    result = String.fromCharCode(parseInt(value) + 65)
  }
  return result
}
// 毫秒转秒
const formatSeconds = function (ms) {
  const result = Math.ceil(ms / 1000)
  return result
}
// 毫秒转分钟
const formatMinutes = function (ms) {
  const minutes = Math.ceil(ms / 60000)
  return minutes
}

// 进行补0操作
const addZero = n => (n < 10 ? '0' + n : n)

// 毫秒转分钟和秒  格式 10:01
const msToMinAndSeconds = function (ms) {
  const days = Math.floor(ms / 1000 / 60 / 60 / 24)
  const hours = Math.floor(ms / 1000 / 60 / 60 - 24 * days)
  const minutes = Math.floor(ms / 60000) - 60 * hours
  const seconds = ((ms % 60000) / 1000).toFixed(0)

  let result = ''
  if (days >= 1) {
    result = days + 'd' + ' ' + hours + 'h'
  } else {
    result = addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds)
  }

  return result
}

// 毫秒转mm:ss
const msToMmSs = function (ms) {
  let m = Math.floor(ms / 1000 / 60)
  let s = Math.floor(ms / 1000)
  m = addZero(m) + ':'
  s = addZero(s % 60)
  return m + s
}

const formatNumber = function (num) {
  return num ?? '--'
}

// 根据学员id生成一个背景色
const getAvatarBgColor = function (uid) {
  const BACKGROUND_COLORS = ['#29CC7A', '#1E96FE', '#5865F2', '#A259FF', '#E774E9', '#EB459F', '#FF8080', '#FFC619']

  return BACKGROUND_COLORS[uid % BACKGROUND_COLORS.length]
}

// 试题的选型
const questionOption = function(value) {
  return String.fromCharCode(parseInt(value) + 65)
}

// 试题类型转换
const questionType = function (value) {
  const map = {
    1: '选择题',
    2: '填空题',
    3: '判断单题',
    4: '解答题',
    5: '综合题',
    6: '完形填空',
    7: '阅读理解',
    8: '跟读单词',
    9: '跟读句子',
    10: '跟读短文',
    11: '英语多空题'
  }
  return map[value] ?? '--'
}

// 向上取整分钟
const ceilMsToM = val => {
  if (typeof val !== 'number') {
    return '--'
  }
  return Math.ceil(Number(val) / 1000 / 60)
}
// 向下取整分钟
const floorMsToM = val => {
  if (typeof val !== 'number') {
    return '--'
  }
  return Math.floor(Number(val) / 1000 / 60)
}

const ifNull = val => {
  if (val === null || typeof val === 'undefined') {
    return '--'
  }
  return val
}

const ifNullRate = val => {
  if (val === null || typeof val === 'undefined') {
    return '--'
  }
  return Number(parseFloat(val * 100).toFixed(0))
}

// 获取标签颜色
const getTagColor = (val, type) => {
  let colorName = 'gray'
  const COLOR_TYPE_MAP = {
    // 讲次类型
    lessonType: {
      2: 'blue', // AI课
      3: 'darkGreen' // 自由练
    },
    // 科目
    versionType: {
      2: 'green', // 数学
      3: 'red', // 语文
      4: 'lightBlue', // 英语
      5: 'darkPurple' // 物理
    },
    // AI课学习流程
    aiType: {
      1: 'lightBlue', // 学前自检
      2: 'purple', // 知识吸纳
      3: 'lightBlue1', // 学后展示
      4: 'darkGreen' // 已完成
    },
    // 题目的正确性
    resultType: {
      0: 'darkRed', // 错误
      1: 'darkGreen' // 正确
    },
    rankType: {
      1: 'rank1',
      2: 'rank2',
      3: 'rank3'
    }
  }

  if (type) {
    colorName = COLOR_TYPE_MAP[type][val]
  }

  return colorName
}

/**
 * 获取标签名
 * @param {*} val 值
 * @param {*} type 类型
 */
const getTagName = (val, type) => {
  let tagName = '标签'
  const TAG_NAME_MAP = {
    // 知识点标签
    knowledge: {
      1: '基础',
      2: '进阶',
      3: '复习',
      4: '拔高',
      5: '超越'
    },
    // 认知难度
    studentLevel: {
      1: '基础',
      2: '进阶',
      3: '拔高'
    },
    // 易错程度
    fallible: {
      1: '普通',
      2: '易错'
    },
    // 重要程度
    extent: {
      1: '一星',
      2: '重要',
      3: '非常重要'
    }
  }

  if (type && val) {
    tagName = TAG_NAME_MAP[type][val]
  }

  return tagName
}

/**
 * 获取科目名称
 * @param {*} val
 */
const getSubjectName = val => {
  const { subjectList } = store.state.common.baseData
  const result = subjectList.find(item => parseInt(item.key) === parseInt(val))
  return result?.value ?? '--'
}

/**
 * 获取学科名称
 * @param {*} val
 */
const getSubjectProductName = val => {
  const { subjectProductList } = store.state.common.baseData
  const result = subjectProductList.find(item => parseInt(item.key) === parseInt(val))
  return result?.value ?? '--'
}

/**
 * 获取年级名称
 * @param {*} val
 */
const getGradeName = val => {
  const { gradeList } = store.state.common.baseData
  const result = gradeList.find(item => parseInt(item.key) === parseInt(val))
  return result?.value ?? '--'
}

/**
 * 获取学期名称
 * @param {*} val
 */
const getPeriodName = val => {
  const { periodList } = store.state.common.baseData
  const result = periodList.find(item => parseInt(item.key) === parseInt(val))
  return result?.value ?? '--'
}

/**
 * 获取教材版本名称
 * @param {*} val
 */
const getBookVersionName = val => {
  const { bookVersionList } = store.state.common.baseData
  const result = bookVersionList.find(item => parseInt(item.key) === parseInt(val))
  return result?.value ?? '--'
}

/**
 * 获取体系名称
 * @param {*} val
 */
const getSchemeName = val => {
  const { schemeList } = store.state.common.baseData
  const result = schemeList.find(item => parseInt(item.key) === parseInt(val))
  return result?.value ?? '--'
}

/**
 * 获取上下册名称
 * @param {*} val
 */
const getVolumeName = val => {
  const { volumeList } = store.state.common.baseData
  const result = volumeList.find(item => parseInt(item.key) === parseInt(val))
  return result?.value ?? '--'
  // return result ? result.value : val
}

const getRankName = val => {
  const RANK_MAP = {
    1: '倔强青铜',
    2: '秩序白银',
    3: '荣耀黄金'
  }
  return RANK_MAP[val] ?? '--'
}

const getSex = val => {
  const SEX = {
    0: '女',
    1: '男'
  }
  return SEX[val] ?? '--'
}

const colatex2svgHandle = (val, size = 14, color = '#000') => colatex2svg(val, size, color) // 公式解析 size 公式字号大小number color 颜色值 string css颜色值如#ff000格式

// 判断题，结果
// eslint-disable-next-line eqeqeq
const getTrueFalseName = val => (val == false ? '错' : '对')

// 权限认证
const getPermissionText = val => {
  const freeze_text = '您的账号已被冻结'
  const overdue_text = '您的教师账号已到期，请及时联系管理员续费'
  const no_permission_text = '只支持“教师、教务、管理员”角色登录'

  const TEXT_MAP = {
    0: freeze_text,
    2: overdue_text,
    4: overdue_text,
    5: overdue_text,
    403: no_permission_text
  }

  return TEXT_MAP[val]
}

const getAccountstateName = val => {
  const RANK_MAP = {
    0: '正常',
    1: '未验证',
    2: '学习卡到期',
    3: '未激活',
    4: '已验证',
    5: '无学习卡'
  }
  return RANK_MAP[val] ?? '--'
}

export default {
  getSceneName,
  getStateName,
  getBookStateName,
  getResultName,
  getAttendanceName,
  getFinishedName,
  formatPercent,
  optionsName,
  formatSeconds,
  formatMinutes,
  msToMinAndSeconds,
  formatNumber,
  getAvatarBgColor,
  questionOption,
  questionType,
  ceilMsToM,
  floorMsToM,
  ifNull,
  ifNullRate,
  getTagColor,
  getTagName,
  getSubjectName,
  getGradeName,
  getSubjectProductName,
  getPeriodName,
  getBookVersionName,
  getSchemeName,
  getVolumeName,
  getRankName,
  colatex2svgHandle,
  getTrueFalseName,
  getSex,
  getPermissionText,
  getClassStatusName,
  getAccountstateName,
  msToMmSs
}